// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsAppButton_whatsappButton__8Vdpo","pulse":"WhatsAppButton_pulse__dIfCr","tooltip":"WhatsAppButton_tooltip__Fkhte","icon":"WhatsAppButton_icon__MfpsC"};